import React from 'react';
import Footer from '../Fotter';

function Delivery() {
    return (
        <div>
            <div className="container mx-auto px-4 py-6">
                <h1 className="text-2xl font-bold mb-4">Delivery Information</h1>
                <section className="mb-8">
                    <h2 className="text-xl font-semibold mb-2">Shipping</h2>
                    <h3 className="text-lg font-medium mb-2">What are the delivery charges?</h3>
                    <ul className="list-disc list-inside space-y-2">
                        <li><strong>Free:</strong> Shipping charges are free for orders over 2500 Rs.</li>
                        <li><strong>Prepaid:</strong> Shipping costs for orders under Rs 2500 will be Rs 71.</li>
                        <li><strong>COD:</strong> The shipping charge will be Rs 71 for Cash on Delivery orders.</li>
                    </ul>
                </section>

                <section className="mb-8">
                    <h3 className="text-lg font-medium mb-2">Why does the delivery date not correspond to the delivery timeline of X-Y business days?</h3>
                    <p className="text-gray-700 leading-relaxed">
                        It is possible that the Seller or our courier partners have a holiday between the day your order was placed and the date of delivery, based on the timelines shown on the product page. In this case, we add a day to the estimated date. Some courier partners and Sellers do not work on Sundays, and this is factored into the delivery dates.
                    </p>
                </section>

                <section className="mb-8">
                    <h3 className="text-lg font-medium mb-2">What is the estimated delivery time?</h3>
                    <p className="text-gray-700 leading-relaxed mb-2">
                        Sellers generally procure and ship the items within the time specified on the product page. Business days exclude public holidays and Sundays.
                    </p>
                    <p className="text-gray-700 leading-relaxed">Estimated delivery time depends on the following factors:</p>
                    <ul className="list-disc list-inside space-y-2">
                        <li>The Seller offering the product.</li>
                        <li>Product’s availability with the Seller.</li>
                        <li>The destination to which you want the order shipped and the location of the Seller.</li>
                    </ul>
                </section>

                <section className="mb-8">
                    <h3 className="text-lg font-medium mb-2">Are there any hidden costs (sales tax, octroi etc.) on items sold by Sellers on GWS Shopsy ?</h3>
                    <p className="text-gray-700 leading-relaxed">
                        There are <strong>NO hidden charges</strong> when you make a purchase on GWS Shopsy. List prices are final and all-inclusive. The price you see on the product page is exactly what you would pay.
                    </p>
                    <p className="text-gray-700 leading-relaxed">
                        Delivery charges are not hidden charges and are charged (if at all) extra depending on the Seller’s shipping policy.
                    </p>
                </section>

                <section className="mb-8">
                    <h3 className="text-lg font-medium mb-2">Why does the estimated delivery time vary for each seller?</h3>
                    <p className="text-gray-700 leading-relaxed">
                        Delivery times are influenced by product availability, geographic location of the Seller, your shipping destination, and the courier partner’s time-to-deliver in your location. Enter your default pin code on the product page for more accurate delivery times.
                    </p>
                </section>

                <section className="mb-8">
                    <h3 className="text-lg font-medium mb-2">Seller does not/cannot ship to my area. Why?</h3>
                    <p className="text-gray-700 leading-relaxed">
                        Whether your location can be serviced or not depends on:
                    </p>
                    <ul className="list-disc list-inside space-y-2">
                        <li>Whether the Seller ships to your location.</li>
                        <li>Legal restrictions, if any, in shipping particular products to your location.</li>
                        <li>The availability of reliable courier partners in your location.</li>
                    </ul>
                    <p className="text-gray-700 leading-relaxed">
                        At times, Sellers prefer not to ship to certain locations. This is entirely at their discretion.
                    </p>
                </section>

                <section className="mb-8">
                    <h3 className="text-lg font-medium mb-2">Why is the CoD option not offered in my location?</h3>
                    <p className="text-gray-700 leading-relaxed">
                        Availability of CoD depends on the ability of our courier partner servicing your location to accept cash as payment at the time of delivery. Courier partners have limits on the cash amount payable on delivery depending on the destination.
                    </p>
                </section>

                <section className="mb-8">
                    <h3 className="text-lg font-medium mb-2">I need to return an item, how do I arrange for a pick-up?</h3>
                    <p className="text-gray-700 leading-relaxed">
                        Returns are easy. Contact us to initiate a return. Ekart Logistics will facilitate the pick-up of the item wherever possible. If not, you can return the item through a third-party courier service. Return fees are borne by the Seller.
                    </p>
                </section>

                <section className="mb-8">
                    <h3 className="text-lg font-medium mb-2">Does GWS Shopsy deliver internationally?</h3>
                    <p className="text-gray-700 leading-relaxed">
                        As of now, GWS Shopsy doesn’t deliver items internationally. Purchases can be made on our site with credit/debit cards issued in India and 21 other countries, but the delivery address must be in India.
                    </p>
                </section>

                <section className="mt-8">
                    <h2 className="text-xl font-semibold mb-4">Customer Support</h2>
                    <p><strong>Address:</strong> Shop No. 4, 105 Jai Bajrang Nagar Keladevi Road, Happy Tower In Front of King George School Dewas, Dewas Madhya Pradesh, 455001</p>
                    <p><strong>Phone:</strong> +91 8047154521</p>
                    <p><strong>E-mail:</strong> info@gwsshopsy.com</p>
                    <p><strong>Website:</strong> <a href="http://www.gwsshopsy.com" className="text-blue-500 underline">www.gwsshopsy.com</a></p>
                </section>

            </div>
            <Footer />

        </div>

    );
}

export default Delivery;
